export var getChipStyles = function (backgroundColour, borderColours, padding) {
    var paddingToAdd = padding !== '' ? padding : 'px-3 py-1';
    return "flex flex-shrink-0 flex-row items-center justify-between ".concat(paddingToAdd, " rounded-full border border-").concat(borderColours, " bg-").concat(backgroundColour);
};
//# sourceMappingURL=status-chip.styles.js.map